// Access environment variables (build-time or runtime)

// Declare the window.__ENV__ type
declare global {
    interface Window {
        __ENV__?: Record<string, string>;
    }
}

export const env = {
    // First check runtime variables from window.__ENV__
    // Then fall back to build-time variables from import.meta.env
    // Then provide a default value
    get: (name: string, defaultValue = ''): string => {
        if (window.__ENV__ && window.__ENV__[name] && window.__ENV__[name] !== 'placeholder') {
            return window.__ENV__[name];
        }

        const buildTimeValue = import.meta.env[name];

        return buildTimeValue || defaultValue;
    }
};

// Example usage:
// const apiUrl = env.get('VITE_API_URL', 'http://default-api.com');